import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMathAngle = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		d: "M7.962 1.987a.75.75 0 1 0-1.424-.474l1.424.474ZM1.75 18.25l-.712-.237A.75.75 0 0 0 1.75 19v-.75Zm5.5-16.5-.712-.237-5.5 16.5.712.237.712.237 5.5-16.5-.712-.237Zm-5.5 16.5V19h16.5v-1.5H1.75v.75ZM5 8.5l-.244.709c3.972 1.37 6.9 4.797 7.246 9.1l.748-.06.748-.06c-.399-4.95-3.77-8.852-8.254-10.398L5 8.5Zm13.25.5h-.75a1.5 1.5 0 0 1-1.5 1.5V12a3 3 0 0 0 3-3h-.75ZM16 11.25v-.75A1.5 1.5 0 0 1 14.5 9H13a3 3 0 0 0 3 3v-.75ZM13.75 9h.75A1.5 1.5 0 0 1 16 7.5V6a3 3 0 0 0-3 3h.75ZM16 6.75v.75A1.5 1.5 0 0 1 17.5 9H19a3 3 0 0 0-3-3v.75Z"
	})]
});
const ForwardRef = forwardRef(SvgMathAngle);
export { ForwardRef as ReactComponent };
